import ListingCardGroup from "./ListingCardGroup";
import { Container } from "react-bootstrap";
export default function Vendors() {
  const pvVendors = [
    {
      id: 1,
      name: "SunPower",
      description:
        "You can save more money with better solar panels, and you can save more than just money with SunPower. ",
      logo_url:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8AGwGf0Sru7PSjoDIZhC6gubXX40CrsWB-m_boQAq&s",
    },
    {
      id: 2,
      name: "Powershingle",
      description:
        "PowerShingle® elevated solar structures cost less than conventional metal roof canopies and pay for themselves.",
      logo_url:
        "https://b3023829.smushcdn.com/3023829/wp-content/uploads/2021/06/PowerShingle-Horz@3x-1.png?lossy=1&strip=1&webp=1",
    },
    {
      id: 3,
      name: "Hanwha Qcells",
      description:
        "Hanwha Qcells is a major manufacturer of photovoltaic cells.",
      logo_url:
        "https://www.q-cells.eu/typo3conf/ext/mmpackageqcellsbase/Resources/Public/Images/qcells-logo.svg",
    },
    {
      id: 4,
      name: "Jinko Solar",
      description:
        "JinkoSolar achieves AAA ranking in PV ModuleTech bankability ratings. ",
      logo_url:
        "https://upload.wikimedia.org/wikipedia/en/thumb/7/74/Jinko_Solar_logo.svg/440px-Jinko_Solar_logo.svg.png",
    },
    {
      id: 5,
      name: "Vikram Solar",
      description:
        "Bringing a new dawn From Natural Resources to Natural Energy",
      logo_url:
        "https://upload.wikimedia.org/wikipedia/en/thumb/7/76/Vikram_Solar_logo.svg/440px-Vikram_Solar_logo.svg.png",
    },

    {
      id: 6,
      name: "JA Solar",
      description:
        "We design, develop, manufacture and sell solar cell and solar module products",
      logo_url:
        "https://media.licdn.com/dms/image/C510BAQGInFN4jzHQWQ/company-logo_200_200/0/1547524101210?e=2147483647&v=beta&t=Q-6R32guLAAA-klp548lPFlzLHZnoXiiugzXrsLK2kY",
    },
    {
      id: 7,
      name: "Trina Solar",
      description:
        "Trina Solar is a world leader in solar energy innovation and reliability.",
      logo_url:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Trina_Solar_logo.svg/1599px-Trina_Solar_logo.svg.png?20150906080403",
    },
    {
      id: 8,
      name: "LONGi Green Energy Technology",
      description: "The World's Leading Supplier of Solar PV Solutions",
      logo_url: "https://www.longi.com/_nuxt/img/logo.f95f405.svg",
    },
  ];

  const subscriberVendors = [
    {
      id: 1,
      name: "Arcadia",
      description:
        "Arcadia is a tech company empowering energy innovators and consumers to fight the climate crisis.",
      logo_url:
        "https://static.wixstatic.com/media/a89dc9_8ce3473773e24b0886128d719a13466a~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/BlueRock.jpg",
    },
    {
      id: 2,
      name: "Common Energy",
      description:
        "Common Energy connects individuals to nearby solar and wind projects in minutes",
      logo_url:
        "https://media.licdn.com/dms/image/C4D0BAQEnaMDCXtfi4A/company-logo_200_200/0/1620415190583?e=2147483647&v=beta&t=V64HQ8bwdlmPgOQY6nwJZrmunVbP4Ne8I6nAWwOiJt0",
    },
    {
      id: 3,
      name: "Ampion",
      description:
        "Ampion members receive regular savings on their electricity bills with no added investments or fees.",
      logo_url:
        "https://image.pitchbook.com/HFFFafe3YKb8C6zZSIXJhHRfSID1643958530027_200x200",
    },
    {
      id: 4,
      name: "Solstice",
      description:
        "Bringing affordable solar power to the 77% of Americans who cannot install a rooftop system",
      logo_url:
        "https://solarimpulse.com/files/companies/logo/2017-11-13-224532/Solstice.png",
    },
  ];

  const EPCs = [
    {
      id: 1,
      name: "Solv Energy",
      description:
        "SOLV Energy is a solar EPC and services provider for the utility, high-voltage substation and storage markets across North America.",
      logo_url: "https://www.solvenergy.com/assets/images/sre-full-logo.svg",
    },
    {
      id: 2,
      name: "Blattner",
      description:
        "Blattner Company is a diversified renewable energy contractor providing leading expertise and collaborative construction solutions nationwide.",
      logo_url:
        "https://www.solarpowerworldonline.com/wp-content/uploads/2012/11/Blattner_-e1630587287318-368x300.jpg",
    },
    {
      id: 3,
      name: "Moss",
      description:
        "Moss is a national, privately held construction firm providing innovative solutions resulting in award-winning projects.",
      logo_url:
        "https://mosscm.com/wp-content/themes/moss/images/moss-logo-bte.png",
    },
    {
      id: 4,
      name: "Signal Energy",
      description:
        "Signal Energy is a leading design/build general contractor providing engineering, procurement, and construction (EPC) services for utility-scale renewable energy",
      logo_url: "https://signalenergy.com/assets/images/se_logo.png",
    },
    {
      id: 5,
      name: "Rosendin Electric",
      description:
        "Rosendin’s experience and unique capabilities allow us to take on challenging solar PV projects in a variety of different locations and environments",
      logo_url:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAAZCAMAAAA8GUGSAAAAllBMVEX///9FVWE7TVrDx8q6v8Lo6erl5uhRX2r6+vq3vMBfa3Xg4uRMW2alq7CepaqiqK2XnqTW2dt1f4dpdX7LztF6hIvw8vfe4u4xUaLN0+Vxg7mNlZuxtrrk6PG6wNqjrc+GlcNlerVDXaYAEY0ANpcAJ5KZpcoMPZlbcbCPnMYAIJBPZ6t7i70gRp0AG48AAImAi5svRFLnmij3AAACSklEQVRIieWWWXPjIAyAQdgBfMU2tuMU59qk3babPfL//9wCwrFpp/vU9Us1Uw6Nqk8IiZiQLyidFbE4Vuw22/3hePr2fNgsjO46O26O536/KHfb4by5PD4tyd3v/OLh++OS3KfxYvvL86RdMSPVuBNsLeNx0+R+LZgTV5UsnUarb0bzVeSmik0jysvWTZv+9WEWjaQZpVB7EqWKwoCbFlQG0rmEzAg4QkbtlK3tOjZ6Ci12iQQ3l2D5JZ8IR1NO3f7H5RoUdASOF6Ef66OExoUMJgtDjNx7Qgjnyo452ht9kyl0RJHLbWBFMuMeyL4/91sSiOMS7uLXGKVSyL3nagXpxNVZGXBJg3GOXFUnb7hXM2x/vl7fcxkyEu1UA2ZMQVIgb0VbrVtMP5fs1gRcQvOAK6gOuC+9m06/gi6KOAClBXnPJUz7u3ZcLZE7EA0iCbjrgGsSwPIZ9/AbG/h63k1KY940SYtrn+d6+ifUBHk2kSRqzq3e5Nn80XbG3fl3g5xmbeTynPoSTsEeOMekr7QY6/ItN6azPFc8rCu7U16HIljRJklSi/6PLgdfovJmhvUNHTPTRxycT1OnUCvXFIbLjVBn4y6Tge8jo4U67CN70i6bzhtroCV2+c7csKgGd2GpO6ps0KiTxXB/N9g6T702MiKdX+nixZdGGD0bU5Hi/eOLkUajky7j+h4D/jDELfn/ktIsnnaYmqFcAJzD7HguGbFSHxl/plQ1n95/NRSKZum/7D9P4rxs/KdO1dZaLvjZI5b/xPoy8hccyR7DNOrFmQAAAABJRU5ErkJggg==",
    },
    {
      id: 6,
      name: "McCarthy Building Companies",
      description:
        "McCarthy’s 157-year tradition of construction excellence and innovation launched into the Renewable Energy market in 2013. ",
      logo_url: "https://media.bizj.us/view/img/12326396/picture1.png",
    },
    {
      id: 7,
      name: "Blue Ridge Power",
      description:
        "Blue Ridge Power is a clean infrastructure construction company for projects across the United States. ",
      logo_url:
        "https://pbs.twimg.com/profile_images/1483906995266723843/W0LFk0MM_400x400.jpg",
    },
    {
      id: 8,
      name: "Primoris Renewable Energy",
      description:
        "Primoris Renewable Energy is a leading power generation EPC (engineering, procurement, construction) specializing in utility and commercial-scale solar power",
      logo_url:
        "https://www.prim.com/~/media/Images/P/Primoris-V4/logo/primoris-black.png?h=62&iar=0&w=138",
    },
  ];
  return (
    <>
      <Container
        style={{ textAlign: "center", marginBottom: "20%", marginTop: "5%" }}
      >
        <h1 style={{ fontWeight: "lighter" }}>PV Module Suppliers</h1>
        <ListingCardGroup listings={pvVendors} buttonText="Request Quote" />

        <br></br>
        <h1 style={{ fontWeight: "lighter" }}>
          Engineering, Procurement, Construction (EPC)
        </h1>
        <ListingCardGroup listings={EPCs} buttonText="Request Quote" />
        <br></br>
        <h1 style={{ fontWeight: "lighter" }}>Subscriber Acquisition</h1>
        <ListingCardGroup
          listings={subscriberVendors}
          buttonText="Request Quote"
        />
      </Container>
    </>
  );
}
